import { Component, computed, inject } from "@angular/core"
import { LegacyCardsComponent } from "./legacy-cards.component"
import { RouterLink } from "@angular/router"
import { NgOptimizedImage } from "@angular/common"
import { UiInheritDirective } from "ui-inherit"
import { NextSectionButtonComponent } from "../../../shared/next-section-button.component"
import { TourScrollToElementComponent } from "../../../tour/tour-scroll-to-element.component"
import { IntroAnchor } from "../../../tour/tour.model"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    LegacyCardsComponent,
    RouterLink,
    UiInheritDirective,
    NextSectionButtonComponent,
    NgOptimizedImage,
    NextSectionButtonComponent,
    TourScrollToElementComponent,
  ],
  providers: [],
  standalone: true,
  template: `
    <e2e-tour-scroll-to-element [elementName]="IntroAnchor.LEGACY_FOR_TODAY"/>
    <div class="row">
      <div class="column gap-20 text-black flex-1 p-5 min-w-[300px]">
        <div>
          <span class="text-2xl font-black">
            THE LEGACY FOR
          </span>
          <span class="text-5xl font-black">
            TODAY
          </span>
        </div>
        <div class="bg-white ml-8">
          <div class="relative w-full">
            <img
              [ngSrc]="blackLivesMatterBannerImage()"
              alt="black lives matter banner"
              style="position: relative"
              class="w-full h-auto aspect-video block"
              [width]="1600"
              [height]="900"
            >
            <div class="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/0 to-white pointer-events-none"></div>
          </div>
          <!--
            style="width: 50%; min-width: 300px; transform: rotate(10deg); padding: 40px; position: relative"
            fill
            -->
          <div class="column p-4 -mt-8 relative z-10">
            <div class="center font-semibold">
              THE STRUCTURAL SITUATION CREATED BY THESE PROGRAMS LARGELY REMAINS THE SAME. EVIDENCE OF THEIR DISPARATE
              IMPACT IS CLEAR.
            </div>
            <div>
              There is a difference between ending further harms, and undoing the harm that has been done. Policies like
              the 1968 Fair Housing Act and the Community Reinvestment Act have been largely focused on ending policies
              and practices like redlining, often without going deeper to undesign the structures of segregation and
              wealth inequality they created. But it is not true to say that we have ended racist policy and practice
              (which often illicitly continue) and therefore we can simply move on. The racial wealth gap, the geography
              of our neighborhoods, the quality of services in those areas, and much more, remain just as redlining
              designed them. So if we want a society that is fair, if we want to ‘move on,’ then we need to undesign
              redlining and policies like it. Let’s take a look at some of the inequalities that exist today.
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 min-w-[300px]">
        <e2e-legacy-cards inherit/>
      </div>

    </div>
    <button
      routerLink="/redline-map"
      class="w-full"
    >
      <e2e-next-section-button/>
    </button>
  `,
  selector: "e2e-legacy",
})
export class LegacyComponent {
  private storageService = inject(StorageService)

  blackLivesMatterBannerImage = computed(() =>
    this.storageService.getFileUrl("/assets/pages/intro/legacy/title-banner-image.jpg")
  )
  // mindyBackground = "url('assets/pages/intro/mindy-background.jpg')"
  protected readonly IntroAnchor = IntroAnchor
}
